document.addEventListener("DOMContentLoaded", () => {
  const currencyRate = parseFloat(window.Shopify.currency.rate) || 1.0;
  const currentCurrency = window.Shopify.currency.active;
  const locale = document.documentElement.lang || undefined;
  let currencyFormatter;

  try {
    currencyFormatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currentCurrency || "USD",
    });
  } catch (_e) {
    currencyFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
  }

  const formatCurrency = (amount) => currencyFormatter.format(Number(amount) || 0);

  const updatePrices = () => {
    const allPrices = document.querySelectorAll("[data-currency-price]");
    /* All data-currency-price values on this site are sourced from Shopify
       itself (Liquid variant/product price, cart AJAX responses, embedded
       product JSON, or the Storefront API's market-aware price fields) -
       Shopify already returns these correctly localized for the active
       market (fixed local pricing or auto-converted), so they must NOT be
       re-converted here. Doing so previously corrupted already-correct
       prices in markets with fixed local pricing (e.g. NZ): the currency
       symbol came out right but the number was wrong. This function now
       only reformats the already-correct number (currency symbol/decimal
       style, cent-conversion where the DOM context requires it). */

    allPrices.forEach((priceEl) => {
      if (!isNaN(priceEl.getAttribute("data-currency-price"))) {
        let priceValue = parseFloat(priceEl.getAttribute("data-currency-price"));
        const needsCentConversion =
          priceEl.closest("product-info") ||
          priceEl.closest("product-recommendations") ||
          priceEl.closest(".custom--tabs") ||
          priceEl.closest(".product-form__buttons") ||
          priceEl.closest(".cart-item__price-wrapper") ||
          priceEl.closest(".cart-drawer__footer") ||
          priceEl.classList.contains("drawer-upsell--item__price") ||
          priceEl.closest(".product-grid");

        if (needsCentConversion) {
          priceValue = priceValue / 100;
        }
        const formattedPriceValue = formatCurrency(priceValue);
        if (priceEl.querySelector("s")) {
          const strikedPrice = priceEl.querySelector("s");
          if (strikedPrice.hasAttribute("data-currency-price")) {
            let strikedPriceValue = parseFloat(
              strikedPrice.getAttribute("data-currency-price")
            );
            if (needsCentConversion && !priceEl.classList.contains("totals__subtotal-value")) {
              strikedPriceValue = strikedPriceValue / 100;
            }
            // Add a fix for cart total else proceed as usual
            if (priceEl.classList.contains("totals__subtotal-value")) {
              if (priceEl.firstChild && priceEl.firstChild.nodeType === Node.TEXT_NODE) {
                priceEl.innerHTML = "";
                priceEl.insertAdjacentHTML(
                  "beforeend",
                  `<s data-currency-price="${strikedPriceValue}">${formatCurrency(
                    strikedPriceValue / 100
                  )}</s> ${formattedPriceValue}`
                );
              } else {
                priceEl.innerHTML = "";
                priceEl.insertAdjacentHTML(
                  "beforeend",
                  `${formattedPriceValue} <s data-currency-price="${strikedPriceValue}">${formatCurrency(
                    strikedPriceValue / 100
                  )}</s>`
                );
              }
            } else {
              // Add fix for erroring value
              if (priceEl.firstChild) {
                priceEl.firstChild.textContent = formattedPriceValue + " ";
              }
              priceEl.querySelector("s").textContent = formatCurrency(strikedPriceValue);
            }
          }
        } else {
          if (priceEl.closest(".cart-item__subscription-select")) {
            priceValue = priceValue / 100;
            const planName = priceEl.getAttribute("data-plan-name");
            priceEl.textContent = planName + " for " + formatCurrency(priceValue);
          } else if (priceEl.classList.contains("product-original-price")) {
            priceEl.textContent = "+" + formatCurrency(priceValue / 100);
          } else {
            // Add fix for erroring value
            if (priceEl && Number.isFinite(priceValue)) {
              priceEl.textContent = formattedPriceValue;
            }
          }
        }
      } else if (priceEl.getAttribute("data-currency-price").includes("+")) {
        let priceAttribute = priceEl.getAttribute("data-currency-price");
        let priceValue = parseFloat(priceAttribute.replaceAll("+", ""));
        const needsCentConversion =
          priceEl.closest("product-info") ||
          priceEl.closest("product-recommendations") ||
          priceEl.closest(".custom--tabs") ||
          priceEl.closest(".product-form__buttons") ||
          priceEl.closest(".cart-item__price-wrapper") ||
          priceEl.closest(".cart-drawer__footer") ||
          priceEl.classList.contains("drawer-upsell--item__price") ||
          priceEl.closest(".product-grid");

        if (needsCentConversion) {
          priceValue = priceValue / 100;
        }
        priceEl.innerHTML = `${formatCurrency(priceValue)}+`;
      }
    });
  };

  updatePrices();

  if (currencyRate !== 1.0) {
    // filters pricing is not in 100s
    document.addEventListener("Collection:Filter:Ready", () => {
      updatePrices();
    });

    document.addEventListener("Collection:Filter:Changed", () => {
      updatePrices();
    });

    document.addEventListener("Recharge:Widget:Enable", () => {
      updatePrices();
    });

    // recharge widget pricing not in 100s
    document.addEventListener("Recharge:Widget:SubscriptionChange", () => {
      updatePrices();
    });

    document.addEventListener("Recharge:Widget:BundleItems", () => {
      setTimeout(() => {
        updatePrices();
      });
    });

    document.addEventListener("ProductInfo:Variant:Changed", () => {
      updatePrices();
    });

    document.addEventListener("Cart:Drawer:Changed", () => {
      updatePrices();
    });

    document.addEventListener("Upsell:Modal:Show", () => {
      updatePrices();
    });

    document.addEventListener("Product:Recommendations:Loaded", () => {
      updatePrices();
    });

    document.addEventListener("Cart:Update", () => {
      updatePrices();
    });
  }
});
